export {
  default,
  getWebCompatElevation
} from '../../../Styles/getPlatformElevation';
